// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withIsVisible = require('client-v2/common/components/is-visible')
const UploadImageModal = require('client-v2/common/containers/upload-image-modal/component-dumb')
// Sibling imports
const uploadImageModalActions = require('./actions')
const {
  fileState,
  isVisibleState,
  savedImageUrlState,
  tipsState
} = require('./selectors')

const headerText = 'Edit Collection banner image'
const imagePurpose = 'mix_header_image'
const imageRequirements = {
  minHeight: 384,
  minWidth: 1500,
  resizeHeight: 786,
  resizeWidth: 4500,
  maxFileSize: 10 * 1024 * 1024, // 10MB
  supportedFormats: ['JPEG', 'GIF', 'PNG'],
  supportedTypes: ['image/jpeg', 'image/gif', 'image/png']
}
const tips = tipsState(imageRequirements)

function mapStateToProps(state) {
  if (!isVisibleState(state)) {
    return { isVisible: false }
  }
  return {
    isVisible: true,
    headerText,
    imagePurpose,
    tips,
    file: fileState(state),
    savedImageUrl: savedImageUrlState(state),
    ...imageRequirements
  }
}

const mapDispatchToProps = {
  onDismiss: uploadImageModalActions.dismiss,
  onDelete: uploadImageModalActions.deleteImage,
  onPreviewError: uploadImageModalActions.showPreviewError,
  onSubmit: uploadImageModalActions.submitImage
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    UploadImageModal
  )
)
